import { Box, Flex, Text } from '@pinchenterprisesnpm/friday-ui'
import { IStrategySelectionShiftParams } from '@src/features/shift-post-v2/components/smart-pay/smart-pay.types'
import {
  getSelectedPayRateStrategy,
  getSmartPaySetup,
} from '@src/features/shift-post-v2/components/smart-pay/smart-pay.utils'
import { ISuggestedPayRateStrategy } from '@src/models/SuggestedPayRates'

interface ISmartPayRateFeedbackProps {
  regularStrategy: ISuggestedPayRateStrategy
  lastMinuteStrategy: ISuggestedPayRateStrategy
  strategySelectionParams: IStrategySelectionShiftParams
  payValue: number
}

const SmartPayRateFeedback = ({
  regularStrategy,
  lastMinuteStrategy,
  strategySelectionParams,
  payValue,
}: ISmartPayRateFeedbackProps) => {
  const selectedPayRateStrategy = getSelectedPayRateStrategy(
    regularStrategy,
    lastMinuteStrategy,
    strategySelectionParams,
  )
  const setup = getSmartPaySetup(Number(payValue), selectedPayRateStrategy)

  // Split the tagline into lines by <br> tags
  const taglineLines = setup.tagline.split(/<br\s*\/?>/i)

  return (
    <Box mb="sm" mt="sm">
      <Flex style={{ color: setup.messageColor }} flexDirection="row">
        <Text fontSize="small" color={setup.messageColor} fontWeight="regular">
          {taglineLines.map((line, index) => (
            <Box key={`${line}-${index}`}>
              {line}
              {index < taglineLines.length - 1 && <br />}
            </Box>
          ))}
        </Text>
      </Flex>
    </Box>
  )
}
export default SmartPayRateFeedback
